import { IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { industryOn, industryOff, tagOn, tagOff, assetTagOn, assetTagOff, workerOn, workerOff } from '@assets/images/main/index';

export default {
  bannerData: [
    {
      icon: workerOn,
      iconInv: workerOff,
      image: '',
      iconText: 'Theo dõi vị trí BLE',
      sub: 'New',
      link: '/vi/beacon/ble',
    },
    {
      icon: industryOn,
      iconInv: industryOff,
      image: '',
      iconText: 'Beacon công nghiệp',
      sub: '',
      link: '/vi/beacon/industry',
    },
    {
      icon: tagOn,
      iconInv: tagOff,
      image: '',
      iconText: 'Beacon nhỏ gọn',
      sub: '',
      link: '/vi/beacon/tag',
    },
    {
      icon: assetTagOn,
      iconInv: assetTagOff,
      image: '',
      iconText: 'Tag tài sản',
      sub: 'New',
      link: '/vi/beacon/asset-tag',
    },
  ],
};
